import { EUserFilterOption, EUserType, FeatureWidget } from '@/_enums/user_type'
import { WidgetModel } from '@/_models/WidgetModel'

export const DEFAULT_WIDGET: WidgetModel[] = [
  {
    width: '1/2',
    height: '1/2',
    order: 1,
  },
  {
    width: '1/2',
    height: '1/2',
    order: 2,
  },
  {
    width: '1/2',
    height: '1/2',
    order: 3,
  },
  {
    width: '1/2',
    height: '1/2',
    order: 4,
  },
]

export const FEATURES_OPTIONS_WIDGET = {
  [FeatureWidget.user_search]: {
    user_type: {
      type: 'select',
      options: [EUserType.all, EUserType.people, EUserType.thing],
    },
    filter_text: {
      type: 'select-filter',
      options: [EUserFilterOption.name, EUserFilterOption.category, EUserFilterOption.san_id],
    },
  },
  [FeatureWidget.indoor]: {
    floor: {
      type: 'select-floor',
      label: 'name',
      value: '_id',
      options: asyncOptions => asyncOptions,
    },
  },
  [FeatureWidget.outdoor]: {
    floor: {
      type: 'select-floor',
      label: 'name',
      value: '_id',
      options: asyncOptions => asyncOptions,
    },
  },
}
